export const API_ROOT = process.env.API_ROOT;
export const APP_URL = process.env.APP_URL;
export const APP_GTM = process.env.APP_GTM;


export const WEBPACK_DEV_SERVER_PORT = process.env.WEBPACK_DEV_SERVER_PORT;
export const WEBPACK_DEV_SERVER_HOST = `http://localhost:${WEBPACK_DEV_SERVER_PORT}`;

export const DATE_FORMAT = 'dd/MM/yyyy';
